import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './openSubmissionsPreview.png';

export const openSubmissionsDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Open Submissions widget is a transparency tool as it
                displays how the algo is working by listing where portions of
                your order are open in the market.
            </div>
            <div>
                It provides an overview of your order, what has executed and how
                the algo is intending to execute.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'open-submissions-preview' }],
};
